var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import mergeWith from 'lodash/mergeWith';
import { api } from 'utils/apis/api';
import { deepOmitBy } from 'utils/deepOmitBy';
export const userStorageApi = api.injectEndpoints({
    endpoints: (builder) => ({
        readUserStorage: builder.query({
            query: ({ keys = [] }) => ({
                version: 4,
                path: 'user-storage',
                params: { keys },
            }),
        }),
        setUserStorage: builder.mutation({
            query: (body) => ({
                version: 4,
                path: 'user-storage',
                method: 'PATCH',
                body,
            }),
            onQueryStarted(patch, { dispatch, queryFulfilled }) {
                return __awaiter(this, void 0, void 0, function* () {
                    const patchResult = dispatch(userStorageApi.util.updateQueryData('readUserStorage', {}, (draft) => {
                        draft = deepOmitBy(mergeWith(draft, patch, (objValue, srcValue) => {
                            // Do not attempt to merge arrays and instead override
                            if (Array.isArray(objValue)) {
                                return srcValue;
                            }
                        }), (value) => value === null);
                    }));
                    try {
                        yield queryFulfilled;
                    }
                    catch (_a) {
                        patchResult.undo();
                    }
                });
            },
        }),
        removeUserStorageByKey: builder.mutation({
            query: ({ key }) => ({
                version: 4,
                path: `user-storage/${key}`,
                method: 'DELETE',
            }),
            onQueryStarted({ key }, { dispatch, queryFulfilled }) {
                return __awaiter(this, void 0, void 0, function* () {
                    const patchResult = dispatch(userStorageApi.util.updateQueryData('readUserStorage', {}, (draft) => {
                        delete draft[key];
                    }));
                    try {
                        yield queryFulfilled;
                    }
                    catch (_a) {
                        patchResult.undo();
                    }
                });
            },
        }),
    }),
});
